import React, { useEffect, useRef } from 'react'
import videojs from 'video.js'

const Preview = (props) => {
  const { innerRef, source, captionPath, autoPlay, bigPlayButton = false, thumbnail } = props
  const playerRef = innerRef || useRef()
  const playerNode = useRef()
  useEffect(() => {
    playerRef.current = videojs(
      playerNode.current,
      {
        fill: true,
        controls: true,
        autoplay: autoPlay !== false,// compare to false so that undefined becomes autoplay = true
        preload: 'auto',
        bigPlayButton,
        poster: thumbnail,
        controlBar: {
          volumePanel: {
            inline: false
          }
        },
        sources: [
          {
            src: source
          }
        ]
      },
      () => {
        // playerRef.current.src(source)
      }
    )
    return () => {
      // on unmount
      playerRef.current.dispose()
    }
  }, [])
  const track = captionPath ? <track src={captionPath} /> : null
  return (
    //player DOM container
    <div className='preview-container'>
      {/* player */}
      <div className='preview-element' data-vjs-player>
        <video className='video-js vjs-16-9' ref={playerNode} playsInline children={track} />
      </div>
    </div>
  )
}

export default Preview
